/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */

<template>
  <ModalExito v-show="mostrarExito" :mostrarExito="mostrarExito" />
  <ModalConfirmacion v-if="mostrarModalConfirmacion" @confirmar="eliminarProveedor" @cancelar="cancelarEliminacion"
    :nombreUsuario="nombreProveedor" />
  <LoadScreen v-if="mostrarLoaderDos" />

  <LayoutPrincipal>
    <ContainerWhite class="modern-container">
      <div class="stepper-container">
        <Stepper :steps="steps" :currentStep="currentStep" />
      </div>
      <div class="content-body">
        <form @submit.prevent="siguientePaso">
          <PasoUno v-if="currentStep === 1" :formData="formData" :listas="listas" @update:formData="updateFormData"
            @update:pasoValido="paso1EsValido = $event" />
          <PasoDos v-if="currentStep === 2" :listas="listas" :formData="formData"
            :idCliente="formData.contactoExistente" :averageKwh="averageKwh" :averagePago="averagePago"
            @update:formData="updateFormData" @set-id-cotizacion="alSeleccionarProyecto" />
          <PasoTres v-if="currentStep === 3" :listas="listas" :formData="formData" :averageKwh="averageKwh"
            :limiteKwp="limitePorTarifa" @update:formData="updateFormData" />
          <PasoCuatro v-if="currentStep === 4" :formData="formData" :listas="listas" ref="pasoCuatroComponent"
            :tiposInstalacion="tiposInstalacion" :cargosAdicionales="cargosAdicionales"
            :financiamientos="financiamientos" :materialesEstructura="materialesEstructura"
            :materialesElectricos="materialesElectricos" @update:formData="updateFormData"
            @update:materialCost="updateMaterialCost" @update:materiales-listas="recibirListasDeMateriales" />
          <PasoCinco v-if="currentStep === 5" :formData="formData" :averagePago="averagePago" :averageKwh="averageKwh"
            :quoteTotals="{
              grandTotal: formData.granTotalGuardado || 0,
              grandSubtotal: formData.subtotalGuardado || 0,
              ivaAmount: formData.ivaGuardado || 0,
              aplicarIVA: formData.aplicarIVA,
              precioPaneles: formData.precioPanelesGuardado || 0,
              precioInversores: formData.precioInversoresGuardado || 0,
              totalEstructura: formData.totalEstructuraGuardado || 0,
              totalElectricoExtras: formData.totalElectricoExtrasGuardado || 0,
              totalMaterialFV: formData.totalMaterialFVGuardado || 0,
              totalElectricoDC: formData.totalElectricoDCGuardado || 0,
              totalElectricoAC: formData.totalElectricoACGuardado || 0,
              totalMaterialAnclaje: formData.totalMaterialAnclajeGuardado || 0,
              totalConMargen10: formData.totalConMargen10Guardado || 0,
              ganaciaTotal: formData.gananciaGuardada,
              totalCostoDirecto: formData.CostoDirecto,
              manoObra: formData.manoObraGuardada || 0,
              otrosCargos: formData.otrosCargos || 0
            }" :consumoHistorico="formData.consumos" :environmentalBenefit="environmentalBenefit"
            :totalCost25Years="totalCost25Years" :tirRoi="tirRoi" :totalKwhHistorico="totalKwhHistorico"
            :totalPagoHistorico="totalPagoHistorico" :roiDetail="roiDetail" @save-draft="guardarBorrador" />
        </form>
      </div>

      <footer class="form-footer">
        <button v-if="currentStep > 1" @click="pasoAnterior" type="button" class="btn-secondary">Regresar</button>
        <button type="button" class="btn-primary" @click="siguientePaso" :disabled="!pasoValido">
          {{ currentStep === steps.length ? 'Finalizar' : 'Guardar y continuar' }}
        </button>
      </footer>

    </ContainerWhite>
  </LayoutPrincipal>
</template>

<script>
import Stepper from '../components/Cotizador/Stepper.vue';
import ContainerWhite from "../layouts/ContainerWhite.vue";
import LayoutPrincipal from "../layouts/layoutPrincipal.vue";
import LoadScreen from "../components/Forms/LoadScreen.vue";
import ModalExito from "../components/Modales/ModalExito.vue";
import ModalConfirmacion from "../components/Modales/ModalConfirmacion.vue";
import PasoUno from '../components/Cotizador/PasoUno.vue';
import PasoDos from '../components/Cotizador/PasoDos.vue';
import PasoTres from '../components/Cotizador/PasoTres.vue';
import PasoCuatro from '../components/Cotizador/PasoCuatro.vue';
import PasoCinco from '../components/Cotizador/PasoCinco';
import clientService from '@/services/clientService';
import quoterService from '@/services/quoterService';
import materialsService from '@/services/materialsService';

export default {
  components: {
    Stepper,
    ContainerWhite,
    LayoutPrincipal,
    ModalExito,
    ModalConfirmacion,
    LoadScreen,
    PasoUno,
    PasoDos,
    PasoTres,
    PasoCuatro,
    PasoCinco,
  },
  data() {
    return {
      paso1EsValido: false,
      idCotizacion: null,
      currentStep: 1,
      steps: ['Contacto', 'Consumo', 'Equipo', 'Otros cargos', 'Confirmación'],
      mostrarExito: false, mostrarModalConfirmacion: false, mostrarLoaderDos: false,
      listas: {
        estados: [],
        fuentes: [
          'Referido',
          'Sitio Web',
          'Llamada en frío',
          'Campaña Digital',
          'Otro'
        ],
        estatus: [],
        proyectosCliente: [],
        paneles: [],
        inversores: [],
      },
      tiposInstalacion: [
        { id: 'concreto', label: 'Instalación en Concreto / Otros' },
        { id: 'lamina', label: 'Instalación en Lámina' },
      ],
      cargosAdicionales: [
        { id: 'viscucos', label: 'viscucos' }, { id: 'bomas', label: 'bomas' }, { id: 'verificacion', label: 'verificación' }, { id: 'estudio-energetico', label: 'Estudio energético' }, { id: 'andamios', label: 'andamios' }, { id: 'aire-acondicionado', label: 'Aire acondicionado X' }, { id: 'microndas', label: 'microndas' },
      ],
      financiamientos: [],

      materialesEstructura: [],
      materialesElectricos: [],

      consumoHistorico: [],

      environmentalBenefit: { co2Reduced: 0, treesPlanted: 0, kmNotDriven: 0 },
      totalCost25Years: { withoutPanels: 0, withPanels: 0, savings: 0 },
      tirRoi: { tir: 0, roiYears: 0, roiMonths: 0 },
      roiDetail: [],

      chartDataLoaded: false,

      formData: {
        contactoExistente: '', nombre: '', apellidoPaterno: '', apellidoMaterno: '',
        telefono: '', celular: '', email: '', estado: '', localidad: '', id_cotizacion: '',
        fuente: '', estatus: '', notas: '', registrarDatosEmpresariales: false,
        nombreProyecto: '', localidadProyecto: '', direccion: '',
        tarifaCFE: '', numeroHilos: '', numeroServicio: '',
        consumos: [],
        porcentajeAutoconsumo: 90, limitarProyecto: false,
        modeloPanel: '', cantidadPaneles: 0,
        tipoInversor: '', cantidadInversores: 0,
        tipoInstalacionSeleccionado: [], cargosSeleccionados: [],
        aplicarIVA: true, roiExento: false, tipoCambio: 'peso', valorDolar: 18.75, ocultarDesglose: false,
        latitud: '',
        longitud: '',
        estado_proyecto: '',
        eficiencia: 75,
        otrosCargos: 0,
        potenciaInstalar: 0,
        nuevoPagoMensualVisual: 0,
        ahorroMensualVisual: 0,
      },
    };
  },
  computed: {
    totalKwhHistorico() {
      return this.consumoHistorico.reduce((sum, item) => sum + (Number(item.kwh) || 0), 0);
    },
    totalPagoHistorico() {
      return this.consumoHistorico.reduce((sum, item) => sum + (Number(item.pago) || 0), 0);
    },
    averageKwh() {
      const consumos = this.formData.consumos || [];
      const validos = consumos.filter(c => parseFloat(c.kwh) > 0);

      if (validos.length === 0) return 0;
      const total = validos.reduce((sum, item) => sum + parseFloat(item.kwh), 0);

      return total / validos.length;
    },
    averagePago() {
      const consumos = this.formData.consumos || [];
      const validos = consumos.filter(c => parseFloat(c.pago) > 0);

      if (validos.length === 0) return 0;

      const total = validos.reduce((sum, item) => sum + parseFloat(item.pago), 0);

      return total / validos.length;
    },
    limitePorTarifa() {
      const tarifa = this.formData.tarifaCFE;
      const limites = {
        '1': 25,
        '1A': 30, '1B': 40, '1C': 85, '1D': 100, '1E': 200, '1F': 250,
        'DAC': 10,
        'PDBT': 25,
        'GDBT': 50,
        'GDMTO': 500,
        'GDMTH': 500
      };

      const limite = limites[tarifa] !== undefined ? limites[tarifa] : 50
      return limite;
    },
    pasoValido() {
      const f = this.formData;

      if (this.currentStep === 1) {
        if (f.contactoExistente) return true;
        const tieneDatosPersonales = f.nombre && f.apellidoPaterno && f.apellidoMaterno && f.estado && f.localidad && f.fuente && f.notas;
        const tieneContacto = f.telefono && f.celular && f.email;

        return tieneDatosPersonales && tieneContacto;
      }
      if (this.currentStep === 2) {
        const f = this.formData;

        const tieneDatosProyecto = f.nombreProyecto &&
          f.tarifaCFE &&
          f.nombreProyecto &&
          f.direccion &&
          f.numeroServicio &&
          f.estado_proyecto &&
          f.localidadProyecto;
        const tieneAlgoDeConsumo = this.averageKwh > 0;
        return tieneDatosProyecto && tieneAlgoDeConsumo;
      }
      if (this.currentStep === 3) {
        return f.idPanel && f.cantidadPaneles > 0 && f.idInversor && f.cantidadInversores > 0;
      }
      if (this.currentStep === 4) {
        return f.granTotalGuardado > 0;
      }

      if (this.currentStep === 5) {
        return true;
      }

      return false;
    },
  },
  created() {
    this.generarPeriodosConsumo();
    this.populateRandomData();
    this.chartDataLoaded = true;
  },

  watch: {
    currentStep(val) {
      if (val === 5) {
        this.$nextTick(() => {
          this.calcularMetricasFinales();
        });
      }
    },

    'formData.granTotalGuardado': function () {
      if (this.currentStep === 5) this.calcularMetricasFinales();
    },

    averageKwh: function (val) {
      if (val > 0 && this.currentStep === 5) this.calcularMetricasFinales();
    }
  },
  methods: {
    recibirListasDeMateriales(payload) {
      console.log("📦 Recibiendo materiales del Paso 4:", payload);
      this.materialesEstructura = payload.estructura;
      this.materialesElectricos = payload.electrico;
    },
    updateFormData(newFormData) {
      this.formData = { ...this.formData, ...newFormData };
    },
    async cargarProyectosDelCliente() {
      if (!this.formData.contactoExistente) return;

      try {
        const response = await quoterService.getProyectosPorCliente(this.formData.contactoExistente);
        this.listas.proyectosCliente = response.data;
      } catch (error) {
        console.log("lol")
      }
    },
    updateMaterialCost({ type, groupName, articulos }) {
      const targetArray = this[type];
      const index = targetArray.findIndex(g => g.nombre === groupName);

      if (index !== -1) {
        targetArray[index].articulos = [...articulos];
      }
    },
    generarPeriodosConsumo() {
      this.formData.consumos = [];
      const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

      for (let i = 0; i < 12; i++) {
        this.formData.consumos.push({
          inicio: meses[i],
          termino: meses[i],
          kwh: null,
          pago: null,
          kwhBase: null, kwhInter: null, kwhPunta: null,
          kwBase: null, kwInter: null, kwPunta: null,
          demanda: null, fp: null
        });
      }
    },
    populateRandomData() {
      const nombres = ["", "", ""]; const apellidos = ["", ""]; const lugares = [{ estado: "", ciudad: "", direccion: "" }];
      const randomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];
      const nombre = randomItem(nombres); const apellido1 = randomItem(apellidos); const lugar = randomItem(lugares);
      const precioKwh = 3.8;
      const consumosLlenos = this.formData.consumos.map(consumo => {
        const mes = consumo.termino.split(" ")[0]; let multiplicadorEstacional = (["Mayo", "Junio", "Julio", "Agosto", "Septiembre"].includes(mes)) ? 1.5 : 1.0;
        const kwh = 0 * multiplicadorEstacional;
        return { ...consumo, kwh: kwh, pago: parseFloat((kwh * precioKwh * (1 + (Math.random() - 0.5) * 0.1)).toFixed(2)) };
      });

      this.formData = {
        ...this.formData, nombre: nombre, apellidoPaterno: apellido1, apellidoMaterno: randomItem(apellidos),
        telefono: ``,
        email: ``,
        estado: lugar.estado,
        localidad: lugar.ciudad, fuente: "",
        estatus: "",
        registrarDatosEmpresariales: "",
        nombreProyecto: ``,
        localidadProyecto: lugar.ciudad, direccion: lugar.direccion,
        tarifaCFE: '',
        numeroServicio: ``,
        consumos: consumosLlenos,
        porcentajeAutoconsumo: 90,
        limitarProyecto: Math.random() > 0.5,
        cantidadPaneles: 0,
        cantidadInversores: 0,
        codigo_royecto: '',
      };
    },
    async siguientePaso() {
      if (this.currentStep === 1) {
        const guardadoConExito = await this.guardarCliente();
        if (guardadoConExito) {
          await this.cargarProyectosDelCliente();
          this.currentStep++;
        } else {
          alert("Error al guardar el cliente. Por favor, revisa los datos.");
        }

      } else if (this.currentStep === 2) {
        const guardadoConExito = await this.guardarProyectoYConsumo();
        if (guardadoConExito) {
          this.currentStep++;
        } else {
          alert("Error al guardar el proyecto y sus consumos.");
        }

      } else if (this.currentStep === 3) {

        if (!this.formData.idPanel || this.formData.cantidadPaneles <= 0) {
          alert("Por favor selecciona un modelo de panel y una cantidad válida.");
          return;
        }

        const datosEquipo = {
          id_panel: this.formData.idPanel,
          id_inversor: this.formData.idInversor,
          cantidad_paneles: this.formData.cantidadPaneles,
          cantidad_inversores: this.formData.cantidadInversores,
          porcentaje_autoconsuma: this.formData.porcentajeAutoconsumo,
          eficiencia: this.formData.eficiencia,
        };

        try {
          this.mostrarLoaderDos = true;
          await quoterService.updateQuoter(this.idCotizacion, datosEquipo);
          this.currentStep++;
          this.$nextTick(() => {
            this.cargarCatalogoMateriales();
          });
        } catch (error) {
          alert("No se pudo guardar la configuración del equipo.");
        } finally {
          this.mostrarLoaderDos = false;
        }
      } else if (this.currentStep === 4) {
        this.mostrarLoaderDos = true;
        if (this.$refs.pasoCuatroComponent) {
          this.$refs.pasoCuatroComponent.syncFormData();
        }

        const paqueteMateriales = {
          estructura: this.materialesEstructura,
          electrico: this.materialesElectricos,
          inputs_estructura: this.formData.configuracionEstructura,
          config: {
            tipoCambio: this.formData.tipoCambio,
            valorDolar: this.formData.valorDolar
          }
        };
        const costoUnitarioReal = this.formData.costoUnitarioManoObra || 1000;
        const cantidadPaneles = this.formData.cantidadPaneles || 0;
        const totalManoObraCalculado = cantidadPaneles * costoUnitarioReal;
        const datosPasoCuatro = {
          subtotal: this.formData.subtotalGuardado || 0,
          iva: this.formData.ivaGuardado || 0,
          gran_total: this.formData.granTotalGuardado || 0,
          otroscargos: this.formData.otrosCargos || 0,
          costo_unitario_mano_obra: costoUnitarioReal,
          mano_de_obra: totalManoObraCalculado,
          tipo_instalacion: (this.formData.tipoInstalacionSeleccionado && this.formData.tipoInstalacionSeleccionado.length > 0)
            ? this.formData.tipoInstalacionSeleccionado[0]
            : 'Personalizado', 

          detalles_materiales: paqueteMateriales,
        };

        try {
          console.log("Enviando Paso 4:", datosPasoCuatro);
          await quoterService.updateQuoter(this.idCotizacion, datosPasoCuatro);

          console.log("Paso 4 guardado con éxito.");
          await new Promise(resolve => setTimeout(resolve, 1500));

          this.calcularMetricasFinales();
          this.currentStep++;

        } catch (error) {
          console.error("Error al guardar paso 4:", error);
          alert("Hubo un error al guardar los costos.");
        } finally {
          this.mostrarLoaderDos = false;
        }

      } else if (this.currentStep < this.steps.length) {
        this.mostrarLoaderDos = true;

        setTimeout(() => {
          this.calcularMetricasFinales();
          this.currentStep++;
          this.mostrarLoaderDos = false;
        }, 2000);

      } else {
        this.finalizarFormulario();
      }
    },
    async guardarCliente() {
      let idUsuarioFinal = null;
      const userDataString = localStorage.getItem('userData');

      if (userDataString) {
        try {
          const userData = JSON.parse(userDataString);
          idUsuarioFinal = userData.id_usuario;
        } catch (e) {
          console.error("Error al leer datos de usuario", e);
        }
      }

      if (!idUsuarioFinal) {
        alert("Error: No se pudo identificar al usuario. Por favor relogueate.");
        return false;
      }

      const datosCliente = {
        nombre: this.formData.nombre,
        apellidoPaterno: this.formData.apellidoPaterno,
        apellidoMaterno: this.formData.apellidoMaterno,
        telefono: this.formData.telefono,
        celular: this.formData.celular,
        correo: this.formData.email,
        estado: this.formData.estado,
        localidad: this.formData.localidad,
        Notas: this.formData.notas,
        FuenteC: this.formData.fuente,
        id_usuario: idUsuarioFinal
      };

      try {
        this.mostrarLoaderDos = true;

        let response;

        if (this.formData.contactoExistente) {
          response = await clientService.updateClient(this.formData.contactoExistente, datosCliente);
        } else {
          response = await clientService.createClient(datosCliente);
          this.formData.contactoExistente = response.data.id_cliente;
        }

        return true;

      } catch (error) {
        console.error(" Error al guardar el cliente:", error.response?.data || error.message);
        return false;

      } finally {
        this.mostrarLoaderDos = false;
      }
    },
    async guardarProyectoYConsumo() {

      if (!this.formData.contactoExistente) {
        alert("Error: No se ha identificado al cliente. Regresa al Paso 1.");
        return false;
      }

      let idUsuarioInstalador = this.getUserIdFromToken();

      const consumosMapeados = this.formData.consumos.map((item, index) => {
        const claveMes = (index + 1).toString().padStart(2, '0');
        const kwh = Number(item.kwh || 0);
        const pago = Number(item.pago || 0);
        const demMax = Number(item.demanda || 0);
        const fp = Number(item.fp || 0);

        return {
          nombre: claveMes,      
          periodo_fin: claveMes,  
          Kwh_Consu: kwh,
          Pago_total: pago,
          kwh_consu: kwh,
          pago_total: pago,

          consumo_base: Number(item.kwhBase || 0),
          consumo_intermedio: Number(item.kwhInter || 0),
          consumo_punta: Number(item.kwhPunta || 0),

          demanda_base: Number(item.kwBase || 0),
          demanda_intermedia: Number(item.kwInter || 0),
          demanda_punta: Number(item.kwPunta || 0),

          demanda_maxima: demMax,
          factor_potencia: fp
        };
      });

      const datosPasoDos = {
        cliente: this.formData.contactoExistente,
        id_cliente: this.formData.contactoExistente,
        id_usuario_instalador: idUsuarioInstalador,

        nombre_proyecto: this.formData.nombreProyecto,
        localidad_proyecto: this.formData.localidadProyecto,
        estado_proyecto: this.formData.estado_proyecto,
        direccion: this.formData.direccion,
        latitud: this.formData.latitud,
        longitud: this.formData.longitud,

        tipo_tarifa: this.formData.tarifaCFE,
        servicio_cfe: this.formData.numeroServicio,

        subtotal: 0, iva: 0, gran_total: 0,
        cantidad_paneles: 0, cantidad_inversores: 0,
        mano_de_obra: 0, otroscargos: 0,

        meses_consumidos: consumosMapeados,
      };

      this.mostrarLoaderDos = true;
      try {
        let response;
        if (this.idCotizacion) {
          response = await quoterService.updateQuoter(this.idCotizacion, datosPasoDos);
        } else {
          response = await quoterService.createQuoter(datosPasoDos);
          this.idCotizacion = response.data.id_cotizacion || response.data.id;
          const codigoRecienCreado = response.data.codigo_proyecto || '';
          this.updateFormData({ id_cotizacion: this.idCotizacion, codigo_proyecto: codigoRecienCreado });
        }

        return true;

      } catch (error) {
        console.error("❌ Error API:", error);

        let errorMsg = "Error del servidor (500).";
        if (error.response && error.response.status === 500) {
          errorMsg = "Error interno (500). Verifica que no haya campos nulos.";
        } else if (error.response?.data) {
          errorMsg = JSON.stringify(error.response.data);
        }
        alert("No se pudo guardar: " + errorMsg);
        return false;
      } finally {
        this.mostrarLoaderDos = false;
      }
    },
    async cargarCatalogoMateriales() {
      if (this.materialesElectricos && this.materialesElectricos.length > 0) return;

      try {
        this.mostrarLoaderDos = true;
        const response = await materialsService.getMaterialesElectricos();

        this.materialesElectricos = response.data;

      } catch (error) {
        console.error("Error cargando materiales:", error);
        this.materialesElectricos = [];
      } finally {
        this.mostrarLoaderDos = false;
      }
    },
    async cargarCatalogosCompletos() {
      try {
        const [resPaneles, resInversores] = await Promise.all([
          materialsService.getPaneles(),
          materialsService.getInversores(),
        ]);

        this.listas.paneles = resPaneles.data;
        this.listas.inversores = resInversores.data;

      } catch (error) {
        console.error("Error al cargar los catálogos:", error);
        alert("No se pudieron cargar los catálogos de equipo. Revisa tu conexión o el backend.");
      }
    },

    async cargarDatosCotizacionExistente() {
      if (!this.idCotizacion) return;

      try {
        this.mostrarLoaderDos = true;
        const response = await quoterService.getQuoterById(this.idCotizacion);
        const data = response.data;
        let configEstructuraRecuperada = [];
        if (data.detalles_materiales) {

          let detalles = data.detalles_materiales;
          if (typeof detalles === 'string') {
            try { detalles = JSON.parse(detalles); } catch (e) { console.error("Error parseando JSON", e); }
          }

          if (detalles.inputs_estructura) {
            configEstructuraRecuperada = detalles.inputs_estructura;
          }

          if (detalles.estructura && Array.isArray(detalles.estructura)) {
            this.materialesEstructura = detalles.estructura;
          }

          if (detalles.electrico && Array.isArray(detalles.electrico)) {
            this.materialesElectricos = detalles.electrico;
          }

          if (detalles.config) {
            this.formData.tipoCambio = detalles.config.tipoCambio || 'peso';
            this.formData.valorDolar = detalles.config.valorDolar || 18.50;
          }

        } else {
          await this.cargarMaterialesDeBD();
        }

        this.formData.subtotalGuardado = parseFloat(data.subtotal || 0);
        this.formData.ivaGuardado = parseFloat(data.iva || 0);
        this.formData.granTotalGuardado = parseFloat(data.gran_total || 0);

        let consumosFormateados = [];
        if (data.meses_consumidos && data.meses_consumidos.length > 0) {
          consumosFormateados = data.meses_consumidos.map(mes => ({
            inicio: mes.nombre || mes.periodo_fin,
            termino: mes.periodo_fin || mes.nombre,

            kwh: Number(mes.Kwh_Consu || mes.kwh_consu || mes.kwh || 0),
            pago: Number(mes.Pago_total || mes.pago_total || mes.pago || 0),

            kwhBase: Number(mes.consumo_base || 0),
            kwhInter: Number(mes.consumo_intermedio || 0),
            kwhPunta: Number(mes.consumo_punta || 0),

            kwBase: Number(mes.demanda_base || 0),
            kwInter: Number(mes.demanda_intermedia || 0),
            kwPunta: Number(mes.demanda_punta || 0),

            demanda: Number(mes.demanda_maxima || 0),
            fp: Number(mes.factor_potencia || mes.fp || 99)
          }));
        } else {

          this.generarPeriodosConsumo();
          consumosFormateados = this.formData.consumos;
        }
        let costoUnitarioRecuperado = 1000; 

        if (data.mano_de_obra && data.cantidad_paneles > 0) {
          costoUnitarioRecuperado = data.mano_de_obra / data.cantidad_paneles;
        }

        const datosRecuperados = {
          contactoExistente: data.id_cliente,
          nombreProyecto: data.nombre_proyecto,
          id_cotizacion: this.idCotizacion,
          codigo_proyecto: data.codigo_proyecto,

          tarifaCFE: data.tipo_tarifa,
          numeroServicio: data.servicio_cfe,
          direccion: data.direccion,
          localidadProyecto: data.localidad_proyecto,
          consumos: consumosFormateados,

          idPanel: data.id_panel ? Number(data.id_panel) : '',
          cantidadPaneles: Number(data.cantidad_paneles) || 0,
          idInversor: data.id_inversor ? Number(data.id_inversor) : '',
          cantidadInversores: Number(data.cantidad_inversores) || 0,
          porcentajeAutoconsumo: Number(data.porcentaje_autoconsuma) || 90,
          eficiencia: data.eficiencia ? Number(data.eficiencia) : 75,

          tipoInstalacionSeleccionado: data.tipo_instalacion ? [data.tipo_instalacion] : [],
          costo_unitario_mano_obra: this.formData.costoUnitarioManoObra || 0,
          otrosCargos: Number(data.otroscargos) || data.otros_cargos || 0,
          manoObraGuardada: Number(data.mano_de_obra) || 0,
          costoUnitarioManoObra: costoUnitarioRecuperado,
          configuracionEstructura: configEstructuraRecuperada,

          tipoCambio: this.formData.tipoCambio,
          valorDolar: this.formData.valorDolar,

          subtotalGuardado: this.formData.subtotalGuardado,
          ivaGuardado: this.formData.ivaGuardado,
          granTotalGuardado: this.formData.granTotalGuardado
        };

        this.updateFormData(datosRecuperados);
        this.$nextTick(() => {
          if (this.formData.cantidadPaneles > 0) {
            this.calcularMetricasFinales();
          }
        });

      } catch (error) {
        console.error("Error cargando la cotización:", error);
        alert("Hubo un error al cargar los datos del proyecto.");
      } finally {
        this.mostrarLoaderDos = false;
      }
    },
    async alSeleccionarProyecto(idNuevo) {
      this.idCotizacion = idNuevo;
      await this.cargarDatosCotizacionExistente();
    },

    async cargarMaterialesDeBD() {
      try {
        const response = await materialsService.getAllMateriales();
        const todosLosMateriales = response.data;

        const grupoConcreto = { nombre: 'Anclaje para concreto', articulos: [] };
        const grupoLamina = { nombre: 'Anclaje para lámina', articulos: [] };
        const electricoTemp = [];

        todosLosMateriales.forEach(mat => {

          const nombreArticulo = mat.Articulo || mat.articulo || "Sin nombre";
          const unidad = mat.Unidad || mat.unidad || "Pieza";
          const precioString = (mat.Precio || mat.precio || "0").toString();
          const costo = parseFloat(precioString.replace('$', '')) || 0;
          const cantidadSugerida = parseInt(mat.cantidad_base) || 0;

          const itemFormateado = {
            id: mat.id_material || mat.id,
            articulo: nombreArticulo,
            unidad: unidad,
            costo: costo,
            cantidad: cantidadSugerida,
          };

          const proveedorRaw = mat.proveedor || mat.tipo_proveedor || "";
          const proveedor = proveedorRaw.toString().toLowerCase().trim();

          const usoRaw = mat.tipo_instalacion || mat.tipoInstalacion || "general";
          const uso = usoRaw.toString().toLowerCase().trim();

          if (proveedor.includes('ferretera') || proveedor.includes('ferreteria')) {

            if (uso === 'lamina' || uso === 'solo lámina' || uso === 'solo lamina') {
              grupoLamina.articulos.push(itemFormateado);
            }
            else if (uso === 'concreto' || uso === 'solo concreto') {
              grupoConcreto.articulos.push(itemFormateado);
            }
            else {
              grupoConcreto.articulos.push(itemFormateado);
              grupoLamina.articulos.push({ ...itemFormateado });
            }

          }
          else if (proveedor.includes('electrico') || proveedor.includes('eléctrico')) {
            const nombreGrupo = "Material Eléctrico General";
            let grupo = electricoTemp.find(g => g.nombre === nombreGrupo);
            if (!grupo) {
              grupo = { nombre: nombreGrupo, articulos: [] };
              electricoTemp.push(grupo);
            }
            grupo.articulos.push(itemFormateado);
          }
        });

        this.materialesEstructura = [grupoConcreto, grupoLamina];
        this.materialesElectricos = electricoTemp;

      } catch (error) {
        console.error("Error cargando materiales:", error);
      }
    },
    getUserIdFromToken() {
      const token = localStorage.getItem('token');

      if (!token) return null;

      try {
        const parts = token.split('.');
        if (parts.length !== 3) {
          return null;
        }

        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        const payload = JSON.parse(jsonPayload);

        const userId = payload.user_id || payload.id;

        return userId;

      } catch (error) {
        console.error("[DEBUG] Error al decodificar:", error);
        return null;
      }
    },

    async guardarBorrador() {
      this.mostrarLoaderDos = true;

      try {
        const datosActuales = {
          subtotal: this.formData.subtotalGuardado || 0,
          iva: this.formData.ivaGuardado || 0,
          gran_total: this.formData.granTotalGuardado || 0,
          precioPanelesGuardado: this.totalPaneles,
          precioInversoresGuardado: this.totalInversores,
          detalles_materiales: {
            estructura: this.materialesEstructura,
            electrico: this.materialesElectricos,
            config: {
              tipoCambio: this.formData.tipoCambio,
              valorDolar: this.formData.valorDolar
            }
          }
        };

        await quoterService.updateQuoter(this.idCotizacion, datosActuales);

        alert("¡Borrador guardado exitosamente! Puedes cerrar y volver más tarde.");

      } catch (error) {
        console.error("Error al guardar borrador:", error);
        alert("No se pudo guardar el borrador.");
      } finally {
        this.mostrarLoaderDos = false;
      }
    },

    calcularMetricasFinales() {
      const pagoMensualPromedio = this.averagePago;
      const consumoMensualPromedio = this.averageKwh;
      const inversion = this.formData.granTotalGuardado;
      const panelSeleccionado = this.listas.paneles.find(p => p.id_panel == this.formData.idPanel);
      const potenciaPanelW = panelSeleccionado ? (panelSeleccionado.Pmax || panelSeleccionado.Potencia) : 550;
      const kwp = (this.formData.cantidadPaneles * potenciaPanelW) / 1000;
      this.formData.potenciaInstalar = kwp;

      const hsp = this.formData.hspGuardado;
      const eficiencia = (this.formData.eficiencia) / 100;

      const generacionMensual = kwp * hsp * 30.4 * eficiencia;
      const generacionAnual = generacionMensual * 12;
      const co2Ton = (generacionAnual * 0.58) / 1000;
      this.environmentalBenefit = {
        co2Reduced: parseFloat(co2Ton.toFixed(2)),
        treesPlanted: Math.floor(co2Ton * 50),
        kmNotDriven: Math.floor(co2Ton * 4000)
      };
      const detalle = [];
      const inflacion = 0;

      let pagoSinSolar = pagoMensualPromedio * 12;
      const consumoAnualTotal = consumoMensualPromedio * 12;

      const precios = this.formData.precios_cfe || {};
      const tarifa = (this.formData.tarifaCFE || '').toUpperCase();
      let minimoCFE = 0;

      if (tarifa.includes('DAC')) minimoCFE = precios.CARGO_FIJO_DAC;
      else if (tarifa.includes('PDBT')) minimoCFE = precios.PDBT?.CARGO_FIJO;
      else if (tarifa.includes('GDMTO')) minimoCFE = precios.GDMTO?.CARGO_FIJO;
      else if (tarifa.includes('GDMTH')) minimoCFE = precios.GDMTH?.CARGO_FIJO;

      const minimoCFEAnual = minimoCFE * 12;

      let consumoNetoCFE = consumoAnualTotal - generacionAnual;
      if (consumoNetoCFE < 0) consumoNetoCFE = 0;

      let pagoEnergiaPura = pagoSinSolar - minimoCFEAnual;
      if (pagoEnergiaPura < 0) pagoEnergiaPura = 0;

      const costoKwhPromedio = consumoAnualTotal > 0 ? (pagoEnergiaPura / consumoAnualTotal) : 0;

      let pagoConSolarBase = minimoCFEAnual + (consumoNetoCFE * costoKwhPromedio);
      let pagoConSolar = pagoConSolarBase;

      this.formData.nuevoPagoMensualVisual = pagoConSolarBase / 12;
      this.formData.ahorroMensualVisual = (pagoSinSolar - pagoConSolarBase) / 12;

      const ahorroAnoUno = pagoSinSolar - pagoConSolarBase;
      let anioRecuperacion = 0;
      let mesesRecuperacion = 0;

      if (ahorroAnoUno > 0 && inversion > 0) {
        const roiDecimal = inversion / ahorroAnoUno;
        anioRecuperacion = Math.floor(roiDecimal);
        mesesRecuperacion = Math.round((roiDecimal - anioRecuperacion) * 12);
        if (mesesRecuperacion === 12) {
          anioRecuperacion += 1;
          mesesRecuperacion = 0;
        }
      }

      let gastoTotalSin = 0;
      let gastoTotalCon = inversion;

      let flujosCaja = [-inversion];

      for (let i = 1; i <= 25; i++) {
        const ahorroAnual = pagoSinSolar - pagoConSolar;

        gastoTotalSin += pagoSinSolar;
        gastoTotalCon += pagoConSolar;

        detalle.push({
          periodo: `Año ${i}`,
          consumoHist: consumoAnualTotal,
          generacion: generacionAnual,
          consumoNeto: consumoNetoCFE,
          nuevoPago: pagoConSolar,
          pagoHist: pagoSinSolar,
          ahorro: ahorroAnual
        });

        flujosCaja.push(ahorroAnual);

        pagoSinSolar *= (1 + inflacion);
        pagoConSolar *= (1 + inflacion);
      }

      this.roiDetail = detalle;

      let tirCalculada = 0;

      if (inversion > 0 && ahorroAnoUno > 0) {
        let min = 0.0;
        let max = 1.0; 
        let guess = 0;

        for (let iteraciones = 0; iteraciones < 100; iteraciones++) {
          guess = (min + max) / 2;
          let npv = 0;

          for (let t = 0; t < flujosCaja.length; t++) {
            npv += flujosCaja[t] / Math.pow(1 + guess, t);
          }

          if (Math.abs(npv) < 0.1) break;

          if (npv > 0) min = guess; 
          else max = guess; 
        }

        tirCalculada = Number((guess * 100).toFixed(2));
      }

      this.totalCost25Years = {
        withoutPanels: gastoTotalSin,
        withPanels: gastoTotalCon,
        savings: gastoTotalSin - gastoTotalCon
      };

      this.tirRoi = {
        tir: tirCalculada,
        roiYears: anioRecuperacion,
        roiMonths: mesesRecuperacion
      };
    },

    pasoAnterior() { if (this.currentStep > 1) { this.currentStep--; } },
    finalizarFormulario() {
      alert("¡Proyecto registrado exitosamente!");
      this.currentStep = 1;
    }
  },
  mounted() {
    this.cargarCatalogosCompletos();

    if (this.idCotizacion) {
      this.$nextTick(() => {
        this.cargarDatosCotizacionExistente();
      });
    }
    this.cargarCatalogosCompletos();

    if (this.formData.contactoExistente) {
      console.log("Cargando proyectos del cliente existente...");
    }
    this.cargarMaterialesDeBD();
  },


};
</script>

<style scoped>
.modern-container {
  --color-primario: #29b9f6;

  --color-secundario: #2a428c;
  --color-borde: #cbd5e1;
  --color-fondo-claro: #f8fafc;
  --color-fondo-blanco: #ffffff;
  --color-exito: #22c55e;
  background-color: var(--color-fondo-blanco);
  border-radius: 16px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.07);
  width: 100%;
  height: 100%;
  padding: 0 40px 30px 40px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.stepper-container {
  margin: 0 -40px;
  padding: 25px 0px 10px;
  flex-shrink: 0;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content-body {
  flex-grow: 1;
  scrollbar-width: thin;
}

.form-footer {
  padding: 20px 0;
  margin-top: auto;
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  gap: 15px;
  justify-content: center;
}

.btn-primary,
.btn-secondary,
.btn-primary-outline {
  border: none;
  border-radius: 8px;
  padding: 0 24px;
  height: 44px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-primary:disabled {
  background-color: #cbd5e1;
  color: #64748b;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

.btn-primary {
  background-color: var(--color-primario);
  color: white;
  box-shadow: 0 4px 10px rgba(47, 141, 183, 0.2);
}

.btn-secondary {
  background-color: var(--color-fondo-claro);
  color: var(--color-texto-secundario);
  border: 1px solid var(--color-borde);
}

@media (max-width: 768px) {
  .modern-container {
    padding: 0 15px 15px 15px;
  }

  .stepper-container {
    margin: 0 -15px;
    padding: 10px 10px 0px;
    display: flow-root;
  }

  .content-body {
    padding-top: 0px;
  }
}
</style>